<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select @change="load" :model="filterFormModel" attribute="group" class="mr-1" :options="[
                            {value:'day',text:$t('byDays')},
                            {value:'week',text:$t('byWeeks')},
                            {value:'month',text:$t('byMonths')},
                            {value:'sale',text:$t('bySales')},
                            {value:'category',text:$t('byCategories')},
                            // {value:'source',text:$t('bySource')},
                            {value:'utm_source',text:$t('bySource')},
                            ]">
            </form-select>
            <form-select v-if="filterFormModel.group === 'sale'" @change="load" :model="filterFormModel" attribute="userStatus" class="mr-1" :options="[
                            {value: null, text:$t('all')},
                            {value: 'activated', text:$t('activated')},
                            {value: 'deactivated', text:$t('deactivated')}
                            ]">
            </form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" :defaultShortcut="3"
                               class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile shadow">
          <h3 class="tile-title">{{ $t('client') }}</h3>
          <apexchart :height="300" :options="chartOptions" :series="chartData"></apexchart>
        </div>
      </div>
      <div class="col-12">
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th rowspan="3"></th>
                  <th :colspan="isGroupByDate ? 13 : 11" class="text-center">{{ $t('client') }}</th>
                  <th :colspan="(filterFormModel.group === 'utm_source' ? 6 : filterFormModel.group === 'category' ? 5 : 4) + clientSizeGroup.length" class="text-center">{{ $t('clientSize') }}</th>
                </tr>
                <tr>
                  <th v-if="isGroupByDate || ['utm_source'].includes(filterFormModel.group)" class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('registerFail') }}</th>
                  <th v-if="isGroupByDate || ['utm_source', 'category'].includes(filterFormModel.group)" class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('registerSuccess') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('referral') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('newPaid') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('paid') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('paidUser') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('willExpire') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('willExpireUser') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('expired') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('expiredUser') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('buyUser') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('additionalUser') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('extend') }}</th>
                  <th class="text-center align-middle" rowspan="2" style="min-width: 100px">{{ $t('upgrade') }}</th>
                  <th class="text-center align-middle" :colspan="clientSizeGroup.length" style="min-width: 100px">{{ $t('clientNumberBySize') }}</th>
                  <th class="text-center align-middle" colspan="3" style="min-width: 100px">{{ $t('userNumber') }}</th>
                </tr>
                <tr>
                  <th v-for="(item, i) in clientSizeGroup" :key="i + 'i4'" rowspan="2" style="min-width: 118px" class="text-center align-middle bg-white">{{ getGroupHeader(item) }} user</th>
                  <th class="text-center align-middle bg-white" rowspan="2" style="min-width: 100px">{{ $t('smallest') }}</th>
                  <th class="text-center align-middle bg-white" rowspan="2" style="min-width: 100px">{{ $t('average') }}</th>
                  <th class="text-center align-middle bg-white" rowspan="2" style="min-width: 100px">{{ $t('biggest') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                  <td v-if="isGroupByDate || ['utm_source'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ sum.registerFail | numFormat }}</span></td>
                  <td v-if="isGroupByDate || ['utm_source', 'category'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ sum.registerSuccess | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.referralTotal | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.newPaid | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.paid | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.paidUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.willExpire | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.willExpireUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.expired | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.expiredUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.buyUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.additionalUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.upgrade | numFormat }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i3'" class="text-center">
                    <span class="text-blue">{{ sum.clientSize ? sum.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.smallestClientSize | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.paidUser / sum.paid | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.biggestClientSize | numFormat}}</span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td v-if="isGroupByDate || ['utm_source'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ avg.registerFail | numFormat('0.00') }}</span></td>
                  <td v-if="isGroupByDate || ['utm_source', 'category'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ avg.registerSuccess | numFormat('0.00') }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.referralTotal | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.newPaid | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.paid | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.paidUser | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.willExpire | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.willExpireUser | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.expired | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.expiredUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.buyUser | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.additionalUser | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.upgrade | numFormat('0.00')}}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i2'" class="text-center">
                    <span class="text-blue">{{ avg.clientSize ? avg.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.smallestClientSize | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.paidUser / avg.paid | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.biggestClientSize | numFormat}}</span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px">{{ label(item) }}</td>
                  <td v-if="isGroupByDate || ['utm_source'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ item.registerFail | numFormat }}</span></td>
                  <td v-if="isGroupByDate || ['utm_source', 'category'].includes(filterFormModel.group)" class="text-center"><span class="text-blue">{{ item.registerSuccess | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.referralTotal | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.newPaid | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.paid | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.paidUser | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.willExpire | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.willExpireUser | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.expired | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.expiredUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.buyUser | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.additionalUser | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extend | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.upgrade | numFormat}}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i1'" class="text-center">
                    <span class="text-blue">{{ item.clientSize ? item.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ item.smallestClientSize | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.paidUser / item.paid | numFormat('0.00')}}</span> </td>
                  <td class="text-center"><span class="text-blue">{{ item.biggestClientSize | numFormat}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment';
import TimeRangePicker from "../../components/TimeRangePicker";
import VueApexCharts from 'vue-apexcharts';
import _ from 'lodash';

export default {
  components: {
    TimeRangePicker,
    'apexchart': VueApexCharts
  },
  data() {
    return {
      filterFormModel: {
        group: 'day',
        userStatus: null
      },
      loading: true,
      data: [],
      sum: {},
      avg: {},
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'line'
        }
      },
      chartData: [],
      clientSizeGroup: [
        {from: null, to: 5},
        {from: 5, to: 10},
        {from: 10, to: 30},
        {from: 30, to: 50},
        {from: 50, to: 100},
        {from: 100, to: 200},
        {from: 200, to: 300},
        {from: 300, to: 500},
        {from: 500, to: null},
      ]
    }
  },
  computed: {
    isGroupByDate() {
      return ['day', 'week', 'month'].includes(this.filterFormModel.group);
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.$service.get('/report/client', {
        params: this.filterFormModel
      }).then(response => {
        this.sum = {};
        this.avg = {};
        this.data = [];
        if (!this.filterFormModel.from || !this.filterFormModel.to) {
          this.filterFormModel.to = moment(Date.now(), 'x').endOf('day').format('x');
          this.filterFormModel.from = moment(Date.now(), 'x').subtract('29', 'day').startOf('day').format('x');
        }
        const clientSizeData = [];
        response.data.clientSize.forEach(item => {
          if ((!this.isGroupByDate && (!item._id || !item.label))) {
            item._id = -1;
            item.label = this.$t('notChoose');
          }
          let index = clientSizeData.findIndex(d => d._id === item._id);
          let groupIndex = this.getGroupIndex(item.clientSize, this.clientSizeGroup);
          if (groupIndex) {
            if (index === -1) {
              clientSizeData.push({
                _id: item._id,
                label: item.label,
                smallestClientSize : item.clientSize,
                biggestClientSize: item.clientSize,
                clientSize: {[groupIndex]: 1},
                paidUser: item.clientSize,
                paid: 1,
              });
            } else {
              if (!clientSizeData[index].clientSize[groupIndex]) {
                clientSizeData[index].clientSize[groupIndex] = 1;
              } else {
                clientSizeData[index].clientSize[groupIndex]++;
              }
              clientSizeData[index].smallestClientSize = Math.min(clientSizeData[index].smallestClientSize, item.clientSize);
              clientSizeData[index].biggestClientSize = Math.max(clientSizeData[index].biggestClientSize, item.clientSize);
              clientSizeData[index].paidUser += item.clientSize;
              clientSizeData[index].paid++;
            }
          }
        });
        this.loadData(clientSizeData);

        if (this.isGroupByDate || ['utm_source', 'category'].includes(this.filterFormModel.group)) {
          this.loadData(response.data.register);
        }
        this.loadData(response.data.expire);
        this.loadData(response.data.order);
        this.loadData(response.data.referral);
        this.data.sort((a, b) => {
          if (a._id === -1) {
           return 1;
          }
          if (b._id === -1) {
           return -1;
          }
          return b._id - a._id
        });

        this.data.forEach(item => {
          for (let key in item) {
            if (!['_id', 'label', 'clientSize'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (this.sum[key]) {
                this.sum[key] += item[key];
              } else {
                this.sum[key] = item[key]
              }
            }
            if (['clientSize'].includes(key)) {
              for (let subKey in item[key]) {
                if (!this.sum[key]) {
                  this.sum[key] = {};
                }
                if (!this.sum[key][subKey]) {
                  this.sum[key][subKey] = item[key][subKey];
                } else {
                  this.sum[key][subKey] += item[key][subKey];
                }
              }
            }
          }
        });
        for (let key in this.sum) {
          if (!['_id', 'label', 'clientSize'].includes(key)) {
            this.avg[key] = Math.round(this.sum[key] / this.data.length);
          }
          if (['clientSize'].includes(key)) {
              this.avg[key] = {};
              for (let subKey in this.sum[key]) {
                this.avg[key][subKey] = Math.round(this.sum[key][subKey] / this.data.length);
              }
          }
        }
        this.setupChart();
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    setupChart() {
      this.chartOptions = {
        xaxis: {
          categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
          labels: {
            rotate: 0
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return new Intl.NumberFormat().format(value);
            }
          },
        },
        chart: {
          zoom: {
            enabled: false
          },
          type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
        }
      };
      let chartData = [
        {
          name: this.$t('newPaid'),
          data: this.data.map(d => d.newPaid ? d.newPaid : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('paid'),
          data: this.data.map(d => d.paid ? d.paid : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('willExpire'),
          data: this.data.map(d => d.willExpire ? d.willExpire : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('willExpireUser'),
          data: this.data.map(d => d.willExpireUser ? d.willExpireUser : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('buyUser'),
          data: this.data.map(d => d.buyUser ? d.buyUser : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('additionalUser'),
          data: this.data.map(d => d.additionalUser ? d.additionalUser : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('extend'),
          data: this.data.map(d => d.extend ? d.extend : 0).slice(0, 99).reverse()
        },
        {
          name: this.$t('upgrade'),
          data: this.data.map(d => d.upgrade ? d.upgrade : 0).slice(0, 99).reverse()
        },
      ];
      if (this.filterFormModel.group !== 'day') {
        chartData.push(
          {
            name: this.$t('paidUser'),
            data: this.data.map(d => d.paidUser ? d.paidUser : 0).slice(0, 99).reverse()
          }
        );
      }
      if (this.isGroupByDate) {
        chartData.unshift(
          {
            name: this.$t('registerFail'),
            data: this.data.map(d => d.registerFail ? d.registerFail : 0).slice(0, 99).reverse()
          },
          {
            name: this.$t('registerSuccess'),
            data: this.data.map(d => d.registerSuccess ? d.registerSuccess : 0).slice(0, 99).reverse()
          }

        );
      }
      this.chartData = chartData;
    },
    loadData(data) {
      data.forEach(item => {
        if ((!this.isGroupByDate && (!item._id || !item.label))) { 
          item._id = -1;
          item.label = this.$t('notChoose'); 
        }
        let index = this.data.findIndex(i => i._id === item._id);
        if (index !== -1) {
         for (const key in item) {
          this.data[index][key] = item[key];
         } 
        } else {
          this.data.push(item);
        }
      });
    },
    getGroupIndex(value, groups) {
      for (const i in groups) {     
        if (!groups[i].from && groups[i].to) {
          if (value < groups[i].to) {
            return i;
          }
        }
        if (groups[i].from && !groups[i].to) { 
          if (value >= groups[i].from) {
            return i;
          }
        }
        if (groups[i].from && groups[i].to) { 
          if (value >= groups[i].from && value < groups[i].to) {
            return i;
          }
        }
      }
    },
    getGroupHeader(item) {
      if (!item.from && item.to) {
        return `< ` + item.to;
      }
      if (item.from && !item.to) {
        return `>= ` + item.from;
      }
      if (item.from && item.to) {
        // return item.from + ' - ' + item.to;
        return `< ` + item.to;
      }
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        if (this.filterFormModel.group === 'day') {
          return moment(item._id, 'x').format('ll');
        }
        if (this.filterFormModel.group === 'week') {
          return `${moment(item._id, 'x').format('ll')} --> ${moment(item._id, 'x').add(6, 'day').format('ll')}`;
        }
        if (this.filterFormModel.group === 'month') {
          return moment(item._id, 'x').startOf('month').format('MM/YYYY');
        }
      }
    },
  },
  watch: {
    "filterFormModel.group": function() {
      this.filterFormModel.userStatus = null
    }
  },
  mounted() {
    this.load()
  },
  i18n: {
    messages: {
      en: {
        client: "Client",
        reportClient: 'Client report',
        day: "Day",
        month: "Month",
        byDays: 'By days',
        byWeeks: 'By weeks',
        byMonths: 'By months',
        bySales: 'By sales',
        byAccounts: 'By supporter',
        byCategories: 'By categories',
        registerFail: 'Register fail',
        registerSuccess: 'Register success',
        paid: "Paid",
        newPaid: 'New paid',
        buyUser: 'Buy more user',
        additionalUser: "Additional user",
        extend: 'Extend',
        upgrade: 'Upgrade',
        willExpire: "Will expire",
        willExpireUser: "Will expire user",
        paidUser: "Paid user number",
        clientSize: "Customer size",
        smallest: "Smallest",
        biggest: "Biggest",
        userNumber: 'User number', 
        clientNumberBySize: "Client number by size",
        notChoose: "Not choose",
        expired: "Expired",
        expiredUser: "Expired user",
        bySource: 'By source',
        byUtmSource: 'By source utm',
        referral: "Referral",
        referralSuccess: "Referral success",
      },
      vi: {
        client: "Khách hàng",
        reportClient: 'Báo cáo khách hàng',
        day: "Ngày",
        month: "Tháng",
        byDays: 'Theo ngày',
        byWeeks: 'Theo tuần',
        byMonths: 'Theo tháng',
        bySales: 'Theo sales',
        byAccounts: 'Theo chăm sóc',
        byCategories: 'Theo ngành',
        registerFail: 'Đăng ký thất bại',
        registerSuccess: 'Đăng ký thành công',
        paid: "Đang trả phí",
        newPaid: 'Trả phí mới',
        buyUser: 'Mua thêm user',
        additionalUser: "Số user mua thêm",
        extend: 'Gia hạn',
        upgrade: 'Nâng cấp',
        willExpire: "Đến hạn",
        willExpireUser: "Số user đến hạn",
        paidUser: "Số user trả phí",
        clientSize: "Quy mô khách hàng",
        smallest: "Nhỏ nhất",
        biggest: "Lớn nhất",
        userNumber: 'Số lượng user', 
        clientNumberBySize: "Số lượng khách hàng theo quy mô user",
        notChoose: "Chưa xác định",
        expired: "Hết hạn",
        expiredUser: "Số user hết hạn",
        bySource: 'Theo nguồn',
        byUtmSource: 'Theo nguồn utm',
        referral: "Giới thiệu",
        referralSuccess: "Giới thiệu thành công",
      }
    }
  }
};
</script>